import { defaultsTo } from '../../utils/utilsGlobal';
import { gql, insertGraphQLFragments } from '../GraphQLClient';
import { fragmentUserBasic, serializeUserBasic } from './serializeUser';


export const fragmentIssueBasic = gql`
  fragment fragmentIssueBasic on Issue {
    id
    title
    insertedAt
    isClosed
    rooms {
      count
    }
    messages {
      count
    }
  }
`;


export const fragmentIssueFull = insertGraphQLFragments(gql`
  fragment fragmentIssueFull on Issue {
    ...fragmentIssueBasic
    notes
    tasks {
      __typename
      providerId
      id
      url
      title
      issuesCount
    }
    closedAt
    closedBy { ...fragmentUserBasic }
  }
`, { fragmentIssueBasic, fragmentUserBasic });


export function serializeIssueBasic(data){
  const { rooms, messages } = data || {};
  return {
    ...defaultsTo(data, {
      id: null,
      cursor: null,
      insertedAt: null,
      isClosed: false,
      title: '',
    }),
    totalLinkedRoomsCount: rooms?.count || 0,
    totalLinkedMessagesCount: messages?.count || 0,
  };
}


export function serializeIssueFull(data){
  const { tasks, closedBy } = data || {};
  const serializedIssueBasic = serializeIssueBasic(data);

  return {
    ...serializedIssueBasic,
    ...defaultsTo(data, {
      notes: '',
      closedAt: null,
    }),
    closedBy: serializeUserBasic(closedBy),
    linkedTasks: tasks || [],
  };
}
